import React from 'react';
import { useProviderAuth } from '@/context/ProviderAuthContext';
import ReviewQRCode from '@/components/ReviewQRCode';
import { QrCode } from 'lucide-react';

export default function ProviderQRCodes() {
  const { provider } = useProviderAuth();

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-6xl mx-auto space-y-6">
      <div>
        <h2 className="text-xl sm:text-2xl font-bold text-stone-900 flex items-center gap-2">
          <QrCode className="text-purple-600" size={22} />
          QR Codes
        </h2>
        <p className="text-stone-600 mt-1 text-sm">Share QR codes with your customers</p>
      </div>

      {provider && provider.id && (
        <ReviewQRCode userType="provider" userId={provider.id} />
      )}
    </div>
  );
}
